angular
	.module('HomepageServices')
	.factory('serviceLookup', require('./service-lookup.factory'))
	.factory('homepageDataService', require('./homepage-data-service.factory'))
	.factory('homepageUtil', require('./homepage-util.factory'))
	.factory('contentService', require('./content-service.factory'))
	.factory('publishingService', require('./publishing-service.factory'))
	.factory('publishingErrorService', require('./publishing-error-service.factory'))
	.factory('authSearchService', require('./search-service.factory'))
	.factory('downloadInfoService', require('./downloadInfo-service.factory.js'))
	.factory('shellDataHomepageService', require('./shell-data-homepage-service.factory'))
    .factory('shutterstockService', require('./shutterstock-service.factory'))
	.filter('publishingPreferencesFilter', require('./publishing-preferences.filter'));





// WEBPACK FOOTER //
// ./app/common/services/index.js